// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgChevronRightIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M8.314 6.316a1.07 1.07 0 0 0 0 1.515l4.17 4.17-4.17 4.17a1.07 1.07 0 1 0 1.516 1.515l4.932-4.933a1.07 1.07 0 0 0 0-1.515L9.83 6.305a1.08 1.08 0 0 0-1.516.01"
    />
  </g>
);
export default SvgChevronRightIcon;
SvgChevronRightIcon.displayName = 'SvgChevronRightIcon';
